export default __webpack_public_path__ + "static/media/logo8.1ed43548.png";